import { render, staticRenderFns } from "./evp.vue?vue&type=template&id=706f1720&scoped=true"
import script from "./evp.vue?vue&type=script&lang=js"
export * from "./evp.vue?vue&type=script&lang=js"
import style0 from "./evp.vue?vue&type=style&index=0&id=706f1720&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "706f1720",
  null
  
)

export default component.exports